<template>
  <div class="flex items-center justify-center mt-16 px-4">
    <div class="w-full max-w-md p-8 space-y-6">
      <!-- Logo -->
      <div class="flex justify-center">
        <img
          :src="require('@/assets/logo-header.png')"
          alt="Logo"
          class="h-auto w-auto"
        />
      </div>

      <!-- Title -->
      <h2 class="text-center text-xl font-extrabold text-gray-800">
        Reimbursement Admin Login
      </h2>

      <!-- Login Form -->
      <form @submit.prevent="submitHandler()">
        <!-- Username -->
        <div class="relative mb-3">
          <span class="absolute left-3 top-1/2 -translate-y-1/2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="rgba(62,83,96,1)"
              height="24"
              width="24"
            >
              <path
                d="M20 22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13Z"
              />
            </svg>
          </span>
          <input
            v-model="username"
            type="text"
            placeholder="Username"
            class="pl-12 w-full px-4 py-2 rounded-md bg-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <!-- Password -->
        <div class="relative mb-6">
          <span class="absolute left-3 top-1/2 -translate-y-1/2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="rgba(62,83,96,1)"
              height="24"
              width="24"
            >
              <path
                d="M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM11 15.7324V18H13V15.7324C13.5978 15.3866 14 14.7403 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 14.7403 10.4022 15.3866 11 15.7324ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16Z"
              />
            </svg>
          </span>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="Enter your password"
            autocomplete="current-password"
            class="pl-12 w-full px-4 py-2 rounded-md bg-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <!-- Login Button -->

        <button
          type="submit"
          class="w-full bg-secondary text-white font-semibold py-3 rounded-md hover:bg-slate-700 transition-colors flex items-center justify-center"
        >
          <template v-if="!loading">Login</template>
          <template v-else>
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          </template>
        </button>

        <div
          v-if="isAlert"
          class="my-6 rounded-lg bg-red-50 border border-red-300 text-red-800 px-4 py-3 text-sm"
        >
          {{ alertMessage }}
        </div>
      </form>
      <HeroSemanticVersion />
    </div>
  </div>
</template>

<script>
import HeroSemanticVersion from "@/components/common/HeroSemanticVersion.vue";
import { ref, reactive, toRefs, inject } from "vue";
export default {
  components: {
    HeroSemanticVersion,
  },
  setup() {
    const axios = inject("$axios");
    const router = inject("$router");
    const store = inject("$store");
    const isAlert = ref(false);
    const alertMessage = ref(null);
    const formData = reactive({
      username: null,
      password: null,
    });
    const loading = ref(false);

    const submitHandler = async () => {
      try {
        loading.value = true;
        let result = await axios.post(`/portal/auth`, formData);
        console.log(result);
        if (result.status === 201) {
          store.commit("getUserLogDetails", result.data.data);
          localStorage.setItem(
            `${process.env.VUE_APP_AUTH_TOKEN}_XXX`,
            result.data.token
          );
          return router.push("/admin/dashboard");
        } else {
          isAlert.value = true;
          loading.value = false;
          alertMessage.value = result.data.message;
        }
        setTimeout(() => {
          isAlert.value = false;
          loading.value = false;
        }, 3000);
      } catch (error) {
        console.log(error);
      }
    };

    return {
      ...toRefs(formData),
      submitHandler,
      isAlert,
      alertMessage,
      loading,
    };
  },
};
</script>
